import React, { FunctionComponent } from 'react';
import { Dispatch } from 'redux';
import Dinero from 'dinero.js';

import { Translate } from 'react-localize-redux';

import moment from 'moment';

import styled, { useTheme } from 'styled-components';

import AppState from '@webapp/store/state';

// Components
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';
import CrossIcon from '@components/basics/icons/cross';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import Box from '@components/layout/box';
import Grid from '@components/basics/grid';
import { Order } from '@webapp/types/orders/order';
import { Coupon } from '@services/product/types/coupon';

import SelectorWrapper from '@components/layout/selector-wrapper';
import BoxSelector from '@components/actions/box-selector';
import { AnimatePresence } from 'framer-motion';
import MotionOpacity from '@components/motion/motion-opacity';
import UnselectedIcon from '@components/basics/icons/unselected';
import { InputField } from '@components/form/input';
import BoxHeader from '@components/layout/box-header';
import StripePaymentCtrl from '@webapp/controllers/payment';
import OrderCtrl from '@webapp/controllers/order';
import RightArrow from '@components/basics/icons/right-arrow';
import SeparatorLine from '@components/basics/separator-line';
import FormContainer from '@components/layout/form-container';
import { connect, useDispatch } from 'react-redux';
import PendingCircle from '@webapp/pages/user-profile/profile/wallet/wallet-history/pending-circle.png';
import { ListEarnings } from '@webapp/store/earnings/action-creators';
import SuccessSubscriptionMenu from '@components/success-subscription-menu';
import SimpleArtist from '@common/types/artist/simple-artist';

import { Stripe, PaymentMethod } from '@stripe/stripe-js';
import { Subscription } from '@services/subscription/types/subscription';
import { CreateSubscription } from '@webapp/store/subscription/action-creators';
import ButtonLoadingCtrl from '@webapp/controllers/button-loading';
import { CustomerMetadata } from '@services/payment/types/api/customer-metadata';
import { SubscriptionType } from '@services/subscription/types/subscription-type';
import { Product } from '@services/product/types/product';
import { Price } from '@common/types/price/price';

import Hint from '@components/basics/hint';
import { EntitySubscription } from '@common/types/subscription-manager/list-subscriptions-response';
import CirclePlaceholder from '@components/basics/circle-placeholder/index';

export interface DetailItemHistory {
  label: React.ReactNode;
  description: string;
  amount: Dinero.Dinero;
  date: Date;
  type: 'earning' | 'payout';
  artistIds?: string[];
  status?: string;
}

interface HistoryDetailItemProps {
  subscriptionProArtist?: EntitySubscription[];
  className?: string;
  isMobile: boolean;
  sectionTitle?: React.ReactNode;
  clientId?: string;
  activeCoupon?: Coupon;
  pendingEarnings: DetailItemHistory[];
  completedEarnings: DetailItemHistory[];
  ownerId?: string;
  setWalletPage: React.Dispatch<React.SetStateAction<boolean>>;
  walletPage?: boolean;
  upgradeToProArtists?: SimpleArtist[];
  product?: Product;
  price?: Price;
}

interface DispatchProps {
  createSubscription: (
    stripe: Stripe | undefined,
    paymentData: PaymentMethod | undefined,
    clientId: string,
    order: Order,
    customer: CustomerMetadata,
    subscriptionType: SubscriptionType,
    currentSubscription?: Subscription,
    subscriptionId?: string,
    trialDays?: number,
    redirectType?: string,
    id?: string,
    checkout_source?: string,
    wallet_history?: string
  ) => CreateSubscription;
}

const mapStateToProps = (state: AppState) => {
  const product = state.products.list.find(
    (p) => p.name === 'Distribution Pro' && p.category === 'PLAN'
  );

  return {
    activeCoupon: state.products.coupons.find((c) => c.isActive),
    isMobile: state.ui.mobile,
    upgradeToProArtists: state.artist.myArtists,
    ownerId: state.user.profile?.id,
    product: product,
    price: product?.prices.find((p) => p.frequency === 'year'),
    subscriptionProArtist: state.subscriptionManager.summary?.artists,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return {
    createSubscription: (
      stripe,
      paymentMethod,
      clientId,
      order,
      customer,
      subscriptionType,
      currentSubscription,
      subscriptionId,
      trialDays,
      redirectType,
      id,
      checkout_source
    ) => {
      return dispatch(
        new CreateSubscription(
          stripe,
          paymentMethod,
          clientId,
          order,
          customer,
          subscriptionType,
          currentSubscription,
          subscriptionId,
          trialDays,
          redirectType,
          id,
          checkout_source
        )
      );
    },
  };
};

const HistoryDetailItem: FunctionComponent<
  HistoryDetailItemProps & DispatchProps
> = ({
  className,
  isMobile,
  activeCoupon,
  pendingEarnings,
  completedEarnings,
  upgradeToProArtists,
  ownerId,
  setWalletPage,
  walletPage,
  product,
  price,
  subscriptionProArtist,
  ...props
}) => {
  const [selected, setSelected] = React.useState('equal');
  const [totalEarnings, setTotalEarnings] = React.useState('');
  const [totalStreams, setTotalStreams] = React.useState('');
  const [earningSelected, setEarningSelcted] = React.useState<boolean[]>([]);
  const [openUpgradeArtist, setOpenUpgradeArtist] =
    React.useState<boolean>(false);
  const [showPaymentPage, setShowPaymentPage] = React.useState<boolean>(false);
  const [basket, setBasket] = React.useState<Order[]>([]);
  const [upgradeToProArtist, setUpgradeToProArtist] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const paymentBtn =
    React.useRef() as React.MutableRefObject<HTMLButtonElement>;

  const [singleSelected, setSingleSelected] = React.useState<boolean>(false);

  const dispatch = useDispatch();
  const theme = useTheme();

  const createSubscription = (
    paymentMethod?: PaymentMethod,
    stripe?: Stripe
  ) => {
    if (!stripe || !paymentMethod) {
      return;
    }
    const order = basket.find((o) => o.product.category === 'PLAN');
    if (order) {
      upgradeToProArtist &&
        upgradeToProArtist.forEach((item) => {
          props.createSubscription(
            stripe,
            paymentMethod,
            item.id,
            order,
            item,
            'artist',
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            'wallet'
          );
        });
      setShowPaymentPage(false);
      setWalletPage(true);
    }
  };

  React.useEffect(() => {
    let pendingEarningArtist =
      pendingEarnings
        ?.filter((item) => item.artistIds && item.artistIds.length > 0)
        ?.map((item) => item.artistIds)
        .flat() || [];
    pendingEarningArtist = pendingEarningArtist.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

    let updatedProArtist: any = upgradeToProArtists?.filter(
      (item) =>
        pendingEarningArtist.includes(item.id) &&
        !subscriptionProArtist
          ?.find((subscription) => item.id === subscription.id)
          ?.subscriptions.find((sub) => sub.plan === 'Distribution Pro')
    );
    let newUpdatedProArtist: any = updatedProArtist?.map((item: any) => {
      item.pendingEarningList = pendingEarnings?.filter(
        (earnings) => earnings.artistIds && earnings.artistIds.includes(item.id)
      );
      return item;
    });
    setUpgradeToProArtist(newUpdatedProArtist || []);

    // for total amount
    if (product && price) {
      let basketArr: Order[] = [
        { product, price, quantity: newUpdatedProArtist.length },
      ];
      setBasket(basketArr);
    }

    // for setting totalEarnings and totalStreams
    let newArr: any = [];

    newUpdatedProArtist.forEach(
      (item) => (newArr = [...item.pendingEarningList, ...newArr])
    );

    setTotalStreams(newArr.length);

    const updatedEarnings = newArr
      .reduce(
        (acc, item) => acc.add(item.amount),
        Dinero({
          amount: 0,
          currency: 'USD',
          precision: 5,
        })
      )
      .toFormat();

    setTotalEarnings(updatedEarnings);
  }, [
    pendingEarnings,
    product,
    price,
    upgradeToProArtists,
    subscriptionProArtist,
  ]);

  const Terms = [
    {
      value: 'equal',
      termLabel: 'Upgrade all artists to Pro',
    },
    {
      value: 'custom',
      termLabel: 'Upgrade select artists',
    },
  ];

  const handleSelected = (value) => {
    setSelected(value);
  };

  React.useEffect(() => {
    if (ownerId) {
      dispatch(new ListEarnings('OWNER', ownerId as string));
    }
  }, [ownerId, dispatch]);

  return (
    <Wrapper>
      <div className="walletMain">
        {walletPage && (
          <>
            <Typography
              type="subheader"
              customFont="medium"
              color={!pendingEarnings?.length ? theme.colors.tertiary : ''}
              style={{ margin: '20px 0px', fontSize: '18px' }}
            >
              <Translate
                id="USER_PROFILE.WALLET.PENDING_TEXT"
                data={{ count: !pendingEarnings?.length ? '(0)' : '' }}
              />
            </Typography>

            {pendingEarnings && pendingEarnings.length > 0 && (
              <Grid>
                <Box className="pendingMainBox" noBorderTop>
                  {pendingEarnings.map((item, index) => (
                    <>
                      <Box className="boxTop">
                        <Box className="boxTopDiv">
                          <ListHeader justifyContent="space-between">
                            <Flex
                              justifyContent="flex-start"
                              alignItems="center"
                              gap={5}
                              className="boxTopFlex"
                            >
                              <Typography customFont="semi-bold">
                                {item.label}
                              </Typography>
                              <Typography customFont="semi-bold">
                                {item.amount.toFormat()}
                              </Typography>
                            </Flex>
                          </ListHeader>
                          <ListHeader justifyContent="space-between">
                            <Flex
                              justifyContent="flex-start"
                              alignItems="center"
                              gap={5}
                              className="boxTopFlex"
                            >
                              <Typography color={theme.colors.tertiary}>
                                {item.description}
                              </Typography>
                              {!isMobile && (
                                <Typography color={theme.colors.tertiary}>
                                  {moment(item.date).format(`MMM DD'YY`)}
                                </Typography>
                              )}
                            </Flex>
                          </ListHeader>
                          {isMobile && (
                            <Typography color={theme.colors.tertiary}>
                              {moment(item.date).format(`MMM DD'YY`)}
                            </Typography>
                          )}
                        </Box>
                        <PendingIconBox>
                          <PendingCircleLoading>
                            <img src={PendingCircle} alt="" />
                          </PendingCircleLoading>
                        </PendingIconBox>
                      </Box>
                      {index !== pendingEarnings.length - 1 && <Separator />}
                    </>
                  ))}
                </Box>
              </Grid>
            )}

            <Typography
              type="subheader"
              customFont="medium"
              color={!completedEarnings?.length ? theme.colors.tertiary : ''}
              style={{ margin: '20px 0px', fontSize: '18px' }}
            >
              <Translate
                id="USER_PROFILE.WALLET.COMPLETED_TEXT"
                data={{ count: !completedEarnings?.length ? '(0)' : '' }}
              />
            </Typography>

            {completedEarnings && completedEarnings.length > 0 && (
              <CompletedGrid>
                <Box className="completedMainBox" noBorderTop>
                  {completedEarnings.map((item, index) => (
                    <>
                      <Box className="boxTop">
                        <Box className="boxTopDiv">
                          <ListHeader justifyContent="space-between">
                            <Flex
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                              justifyContent="flex-start"
                              alignItems="center"
                              gap={5}
                              className="boxTopFlex"
                            >
                              <Typography
                                customFont="semi-bold"
                                color={
                                  item.type === 'payout' &&
                                  item.status === 'failed'
                                    ? theme.colors.error
                                    : theme.colors.black
                                }
                              >
                                {item.label}
                              </Typography>
                              <Typography
                                customFont="semi-bold"
                                color={
                                  item.type === 'payout' &&
                                  item.status === 'failed'
                                    ? theme.colors.error
                                    : theme.colors.black
                                }
                              >
                                {item.amount.toFormat()}
                              </Typography>
                            </Flex>
                          </ListHeader>
                          <ListHeader justifyContent="space-between">
                            <Flex
                              justifyContent="flex-start"
                              alignItems="center"
                              gap={5}
                              className="boxTopFlex"
                            >
                              <Typography
                                style={{
                                  width: '60%',
                                  overflowWrap: 'break-word',
                                }}
                                color={theme.colors.tertiary}
                              >
                                {item.description}
                              </Typography>
                              {!isMobile && (
                                <Typography color={theme.colors.tertiary}>
                                  {moment(item.date).format(`MMM DD'YY`)}
                                </Typography>
                              )}
                            </Flex>
                          </ListHeader>
                          {isMobile && (
                            <Typography color={theme.colors.tertiary}>
                              {moment(item.date).format('MMM DD YY')}
                            </Typography>
                          )}
                        </Box>
                        <CompletedIconBox>
                          {item.type === 'payout' &&
                          item.status === 'failed' ? (
                            <CrossIcon className="circle" />
                          ) : (
                            <CompletedIcon className="icon" />
                          )}
                        </CompletedIconBox>
                      </Box>

                      {index !== (completedEarnings?.length || 0) - 1 && (
                        <Separator />
                      )}
                    </>
                  ))}
                </Box>
              </CompletedGrid>
            )}
          </>
        )}
      </div>

      {openUpgradeArtist && (
        <>
          <Typography
            type="subheader"
            customFont="medium"
            style={{ margin: '20px 0px' }}
          >
            <Translate id="USER_PROFILE.WALLET.UPGRADE_ARTIST_HEADER" />
          </Typography>

          <Box noBorderBottom>
            <BoxWrapper>
              <Typography type="title" customFont="semi-bold" className="mb-40">
                <Translate id="USER_PROFILE.WALLET.UPGRADE_ARTIST_SUB_HEADER" />
              </Typography>

              {upgradeToProArtist.length !== 1 ? (
                <>
                  {Terms.map((term, i) => (
                    <OwnershipTermBox>
                      {upgradeToProArtist.length > 0 && (
                        <TermBox
                          className={`term ${
                            selected === term.value ? 'active' : ''
                          } ${'no-border-bottom'}`}
                          onClick={() => handleSelected(term.value)}
                          key={`${term.value}-${i}`}
                        >
                          <Typography weight="700">{term.termLabel}</Typography>
                          <Flex>
                            {term.value === 'equal' && (
                              <Typography
                                className="recommendedBtn"
                                type="small"
                                weight="700"
                                margin="0px 10px 0px 0px"
                              >
                                <Translate id="USER_PROFILE.WALLET.RECOMMENDED_BUTTON_TEXT" />
                              </Typography>
                            )}
                            <AnimatePresence exitBeforeEnter>
                              {selected === term.value ? (
                                <MotionOpacity>
                                  <CompletedIcon className="icon" />
                                </MotionOpacity>
                              ) : (
                                <MotionOpacity>
                                  <UnselectedIcon className="icon" />
                                </MotionOpacity>
                              )}
                            </AnimatePresence>
                          </Flex>
                        </TermBox>
                      )}
                      {selected === 'custom' && term.value === 'custom' && (
                        <>
                          <AnimatePresence exitBeforeEnter>
                            <TermBox
                              onClick={() => {
                                setSingleSelected(!singleSelected);
                                let checkedArray: boolean[] = [];
                                upgradeToProArtist.forEach(() => {
                                  checkedArray.push(!singleSelected);
                                });
                                setEarningSelcted(checkedArray);
                                if (product && price) {
                                  setBasket([
                                    {
                                      product,
                                      price,
                                      quantity: upgradeToProArtist.length,
                                    },
                                  ]);
                                }
                              }}
                            >
                              <Flex style={{ alignItems: 'center' }}>
                                <InputField
                                  className="input-split relative"
                                  value={`All Artist (${upgradeToProArtist.length})`}
                                  locked={true}
                                  hasClose={false}
                                  customBorderRadius={'4px 0 0 4px'}
                                  style={{ width: '40%' }}
                                />
                                <InputField
                                  label={
                                    <Translate id="USER_PROFILE.WALLET.UPGRADE_STREAM" />
                                  }
                                  className="input-split relative"
                                  value={totalStreams}
                                  locked={true}
                                  hasClose={false}
                                  customBorderRadius={'4px 0 0 4px'}
                                  style={{ width: '30%' }}
                                />
                                <InputField
                                  label={
                                    <Translate id="USER_PROFILE.WALLET.UPGRADE_EARNINGS_TEXT" />
                                  }
                                  className="input-split inputPadding relative"
                                  value={totalEarnings}
                                  locked={true}
                                  hasClose={false}
                                  customBorderRadius={'4px 0 0 4px'}
                                  style={{ width: '30%' }}
                                />
                                <AnimatePresence exitBeforeEnter>
                                  {singleSelected ? (
                                    <MotionOpacity>
                                      <CompletedIcon className="icon" />
                                    </MotionOpacity>
                                  ) : (
                                    <MotionOpacity>
                                      <UnselectedIcon className="icon" />
                                    </MotionOpacity>
                                  )}
                                </AnimatePresence>
                              </Flex>
                            </TermBox>
                            <SeparatorLine />
                            {upgradeToProArtist &&
                              upgradeToProArtist.map((item, index) => (
                                <div style={{ position: 'relative' }}>
                                  <TermBox
                                    key={`${item.id}-${index}`}
                                    onClick={() => {
                                      let selectedArray = JSON.parse(
                                        JSON.stringify(earningSelected)
                                      );
                                      selectedArray[index] =
                                        !selectedArray[index];
                                      setEarningSelcted(selectedArray);
                                      if (product && price) {
                                        setBasket([
                                          {
                                            product,
                                            price,
                                            quantity: selectedArray.filter(
                                              (array) => array
                                            ).length,
                                          },
                                        ]);
                                      }
                                      if (
                                        selectedArray.filter((array) => array)
                                          .length === upgradeToProArtist.length
                                      ) {
                                        setSingleSelected(true);
                                      } else {
                                        setSingleSelected(false);
                                      }
                                    }}
                                  >
                                    <Flex style={{ alignItems: 'center' }}>
                                      <InputField
                                        style={{
                                          paddingRight: '0px',
                                          width: '40%',
                                        }}
                                        className="input-split with-decoration"
                                        value={item.name}
                                        locked={true}
                                        hasClose={false}
                                        customBorderRadius={'4px 0 0 4px'}
                                        leftDecoration={<CirclePlaceholder />}
                                      />
                                      <InputField
                                        label={
                                          <Translate id="USER_PROFILE.WALLET.UPGRADE_STREAM" />
                                        }
                                        className="input-split relative"
                                        value={item.pendingEarningList.length}
                                        locked={true}
                                        hasClose={false}
                                        customBorderRadius={'4px 0 0 4px'}
                                        style={{ width: '30%' }}
                                      />
                                      <InputField
                                        label={
                                          <Translate id="USER_PROFILE.WALLET.UPGRADE_EARNINGS_TEXT" />
                                        }
                                        className="input-split inputPadding relative"
                                        value={item.pendingEarningList
                                          .reduce(
                                            (acc, item) => acc.add(item.amount),
                                            Dinero({
                                              amount: 0,
                                              currency: 'USD',
                                              precision: 5,
                                            })
                                          )
                                          .toFormat()}
                                        locked={true}
                                        hasClose={false}
                                        customBorderRadius={'4px 0 0 4px'}
                                        style={{ width: '30%' }}
                                      />
                                      <AnimatePresence exitBeforeEnter>
                                        <MotionOpacity>
                                          {earningSelected[index] ? (
                                            <CompletedIcon className="icon" />
                                          ) : (
                                            <UnselectedIcon className="icon" />
                                          )}
                                        </MotionOpacity>
                                      </AnimatePresence>
                                    </Flex>
                                  </TermBox>
                                  {index !== item.length - 1 && <Separator />}
                                </div>
                              ))}
                          </AnimatePresence>
                        </>
                      )}
                    </OwnershipTermBox>
                  ))}
                </>
              ) : (
                <>
                  <TermBox key={`${upgradeToProArtist[0].id}-${0}`}>
                    <LeftBox>
                      <InputField
                        style={{ paddingRight: '0px' }}
                        className="input-split inputPadding"
                        value={upgradeToProArtist[0].name}
                        locked={true}
                        hasClose={false}
                        customBorderRadius={'4px 0 0 4px'}
                        leftDecoration={<CirclePlaceholder />}
                      />
                    </LeftBox>
                    <FlexBox>
                      <InputField
                        label={
                          <Translate id="USER_PROFILE.WALLET.UPGRADE_STREAM" />
                        }
                        className="input-split relative"
                        value={upgradeToProArtist[0].pendingEarningList.length}
                        locked={true}
                        hasClose={false}
                        customBorderRadius={'4px 0 0 4px'}
                        style={{ width: '40%' }}
                      />
                      <InputField
                        label={
                          <Translate id="USER_PROFILE.WALLET.UPGRADE_EARNINGS_TEXT" />
                        }
                        className="input-split inputPadding relative"
                        value={upgradeToProArtist[0].pendingEarningList
                          .reduce(
                            (acc, item) => acc.add(item.amount),
                            Dinero({
                              amount: 0,
                              currency: 'USD',
                              precision: 5,
                            })
                          )
                          .toFormat()}
                        locked={true}
                        hasClose={false}
                        customBorderRadius={'4px 0 0 4px'}
                        style={{ width: '60%' }}
                      />
                      <AnimatePresence exitBeforeEnter>
                        <MotionOpacity>
                          <CompletedIcon className="icon" />
                        </MotionOpacity>
                      </AnimatePresence>
                    </FlexBox>
                  </TermBox>
                </>
              )}
            </BoxWrapper>
          </Box>

          <Hint
            className="mb-50"
            noBorderTop
            customTitle={
              <Translate id="USER_PROFILE.WALLET.UPGADE_TO_PRO_HINT_TITLE" />
            }
          >
            <Translate id="USER_PROFILE.WALLET.UPGADE_TO_PRO_HINT_TEXT" />
          </Hint>

          <SelectorWrapper style={{ marginBottom: '100px' }}>
            <BoxSelector
              onClick={() => {
                setOpenUpgradeArtist(false);
                setWalletPage(true);
              }}
              className="selector bgColorCancel"
            >
              Cancel
            </BoxSelector>
            <BoxSelector
              className="selector bgColorUpgrade"
              onClick={() => {
                // setWalletPage(true)
                setOpenUpgradeArtist(false);
                setShowPaymentPage(true);
              }}
            >
              <span>
                {upgradeToProArtist.length === 1
                  ? 'Upgrade Artist'
                  : 'Upgrade Artists'}
              </span>
            </BoxSelector>
          </SelectorWrapper>
        </>
      )}

      {showPaymentPage && (
        <FormContainer>
          <BoxWrapper>
            <Box noBorderBottom>
              <BoxHeader
                title={<Translate id="PAYMENT.QUICK_PAYMENT.TITLE" />}
                text={<Translate id="PAYMENT.QUICK_PAYMENT.TEXT" />}
              />
              <PaymentBtnWrapper></PaymentBtnWrapper>
            </Box>

            <StripePaymentCtrl
              paymentOptions={{
                mode: 'setup',
                currency: 'usd',
                setupFutureUsage: 'off_session',
                paymentMethodCreation: 'manual',
              }}
              onError={() => setLoading(false)}
              isMobile={isMobile}
              paymentBtnRef={paymentBtn}
              onSuccess={(paymentMethod, stripe) => {
                setLoading(false);
                createSubscription(paymentMethod, stripe);
              }}
            />
            <OrderCtrl
              className="textCon"
              title={
                <>
                  <Translate id="PAYMENT.DISTRIBUTION" />
                </>
              }
              total={totalStreams.length}
              recurrent
              basket={basket || []}
            />

            <ButtonLoadingCtrl
              className="GoProBtn"
              isLoading={loading}
              onClick={() => {
                setLoading(true);
                paymentBtn.current.click();
              }}
              form="stripe-editor-form"
              type="submit"
              buttonType="primary"
              fullWidth={isMobile}
              height={77}
            >
              {loading ? (
                <Translate id="PAYMENT.PROCESSING" />
              ) : (
                <Flex justifyContent="space-between" alignItems="center">
                  <Typography weight="700">
                    <Translate id="PAYMENT.BUTTON.GOPRO" />
                  </Typography>
                  <RightArrow />
                </Flex>
              )}
            </ButtonLoadingCtrl>
          </BoxWrapper>
        </FormContainer>
      )}

      <SuccessSubscriptionMenu
        upgradeArtistCount={upgradeToProArtist.length}
        type={'distribution'}
      />
    </Wrapper>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryDetailItem);

const TermBox = styled.div`
  position: relative;
  cursor: pointer;
  padding: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background-color: ${({ theme }) => theme.colors.differentBackground};
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  span {
    transition: color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.primary};
    span {
      color: ${({ theme }) => theme.colors.differentBackground};
    }
  }

  &.no-border-bottom {
    border-radius: 4px 4px 0 0;
  }

  .icon {
    width: 32px;
    height: 32px;
  }
  .icontop {
    margin-top: 10px;
  }

  &:first-child {
    margin-top: 10px;
    ${({ theme }) => `@media screen and ${theme.device.laptopXL}`} {
      margin-top: 20px;
    }
  }

  .input-split {
    &.with-decoration {
      .decoration-right {
        z-index: 0;
      }
      &.parent-menu-open {
        .decoration-right {
          z-index: 2;
        }
      }
    }
  }

  .input-wrapper {
    position: relative;
    /* z-index: 5; */

    & > * {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 35%;

      &:first-child {
        flex-basis: 65%;
      }

      ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
        flex-basis: 30%;

        &:first-child {
          flex-basis: 70%;
        }
      }
    }
  }
  .decoration-left {
    position: absolute;
    top: 60%;
    right: auto;
    left: 17px;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;

    ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
      left: 22px;
    }
  }
`;
const Wrapper = styled.div`
  height: fit-content;
  .wrapper-title,
  .wrapper-actions {
    margin-bottom: 20px;
    @media ${({ theme }) => theme.device.tablet} {
      margin-bottom: 30px;
    }

    .wrapper-filters {
      width: 100%;
    }

    .upgradeArtistText {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 15px;
    }
  }
  @media ${({ theme }) => theme.device.tablet} {
    margin: 0;
  }
  @media screen and (max-width: 391px) {
    .walletMain .cbQKne {
      width: 350px;
    }
    .walletMain .kxhxkw {
      width: 350px;
    }
  }
  @media screen and (min-width: 900px) {
    .textCon {
      min-width: 265px;
      position: absolute;
      top: 0px;
      right: 24px;
    }
    .GoProBtn {
      margin-top: 0px;
      min-width: 265px;
      position: absolute;
      top: 50%;
      right: 24px;
      transform: translate(0px, 75%);
    }
  }
  .bgColorCancel {
    background: #f1f2f5;
  }
  .boxTop {
    display: flex;
    flex-direction: row;
    padding: 0px;
  }

  .boxTopDiv {
    width: 91%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .bgColorCancel {
    background: #f1f2f5;
  }

  .walletMain .cbQKne {
    max-width: 589px;
  }
  .walletMain .kxhxkw {
    max-width: 589px;
  }
  .boxTop {
    display: flex;
    flex-direction: row;
    padding: 0px;
  }

  .boxTopDiv {
    width: 91%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .bgColorUpgrade span {
    color: white;
  }

  .boxTopFlex {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .leftImgStyle {
    margin-top: 17px;
    width: 35px;
    height: 36px;
    border-radius: 50%;
  }
  .recommendedBtn {
    background: #086ee5;
    padding: 9px 7px;
    border-radius: 17px;
    color: white;
    font-size: 12px;
  }

  .inputPadding input {
    padding-right: 0px;
  }
  .relative {
    position: relative;
  }
  .pendingMainBox {
    border-radius: 10px 10px 0px 0px;
  }
  .completedMainBox {
    border-radius: 10px;
  }
`;

const ListHeader = styled(Flex)`
  margin-bottom: 15px;

  .coming-soon {
    color: ${({ theme }) => theme.colors.tertiary};
  }
`;
const OwnershipTermBox = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.differentBackground};
`;

const PaymentBtnWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const BoxWrapper = styled.div`
  display: grid;
  grid-gap: 3px;
`;
const Separator = styled.span`
  height: 1px;
  width: 100%;
  border: 1px dashed ${({ theme }) => theme.colors.border};
  border-bottom: 0;
  margin: 0 auto;
  display: block;

  ${({ theme }) => `@media screen and ${theme.device.laptopL}`} {
    width: 100%;
    margin: 0 auto;
  }
`;

const PendingCircleLoading = styled.div`
  background-color: #fbda80;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  padding: 3px;
  display: grid;
  placeitems: 'center';
`;

const CompletedIconBox = styled.div`
  padding: 38px 0px;

  @media screen and (max-width: 500px) {
    padding: 17px 0px;
  }
`;

const PendingIconBox = styled.div`
  padding: 38px 0px;

  @media screen and (max-width: 500px) {
    padding: 18px 0px;
  }
`;

const CompletedGrid = styled.div`
  margin-bottom: 100px;
  border-radius: 10px;
`;

const FlexBox = styled.div`
  display: flex;
  width: 50%;
  align-items: center;
`;

const LeftBox = styled.div`
  position: relative;
  width: 30%;
`;
